module.exports = __webpack_public_path__ + "static/father-and-daughter-brushing-teeth-in-bathroom-f79dbe06a5168b6a1b21fc124ab73ef1.jpg";